import React, { ReactElement } from "react";
import { RouterOutput, trpc } from "#next/utils/trpc";
import { RenderQuery } from "#next/components/base/RenderQuery";

type TFeatureAccess = RouterOutput["user"]["getOrgFeatureSettings"];

export const FeatureAccessContext = React.createContext<TFeatureAccess>(
  // I cast this default value to TFeatureFlags because I don't want to do <TFeatureFlags | undefined>
  // as that would force all consumers of the context to check whether it was undefined.
  // Also, the default context value is only used if a component tries to read the context
  // without the provider being up-tree, and that should never be the case
  // https://beta.reactjs.org/reference/react/useContext#specifying-a-fallback-default-value
  {} as TFeatureAccess,
);
/**
 * Feature flags are temporary and mostly intended for getting user feedback,
 * whereas feature access settings (this file) are controls that live in the
 * Admin Settings panel of the UI. Feature access controls are usually related to
 * some long-term feature that customers can pay extra money for.
 */
export const LoadFeatureAccess = ({ children }: { children: ReactElement }) => {
  return (
    <RenderQuery
      useQuery={trpc.user.getOrgFeatureSettings}
      input={undefined}
      options={{ trpc: { context: { skipBatch: true } } }}
      render={(data) => {
        return (
          <FeatureAccessContext.Provider value={data}>
            {children}
          </FeatureAccessContext.Provider>
        );
      }}
    />
  );
};
